// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cbbff10e","667":"b08c11a4"}[chunkId] + ".chunk.js";
};